import { COMMITMENT_HEADERS } from "@/utils/enums/graphql";

export const getResultForAsClosure = (data: Dic<any>) => {
  data?.currentPeriod?.headers?.forEach(
    (header: COMMITMENT_HEADERS, index: number) => {
      if (header === COMMITMENT_HEADERS.CLOSURES) {
        if (data?.currentPeriod?.rows?.[index]?.floatValue > 0) {
          return true;
        }
      }
    }
  );
  return false;
};
